import { render, staticRenderFns } from "./Model3D.vue?vue&type=template&id=132acd8e&scoped=true&"
import script from "./Model3D.vue?vue&type=script&lang=js&"
export * from "./Model3D.vue?vue&type=script&lang=js&"
import style0 from "./Model3D.vue?vue&type=style&index=0&id=132acd8e&prod&lang=less&"
import style1 from "./Model3D.vue?vue&type=style&index=1&id=132acd8e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132acd8e",
  null
  
)

export default component.exports